import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { processSteps } from '@/mocks/strategix';

export default function HowWeWork() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Как мы работаем"
          title="Смотрите, как строится наша работа"
          description="Шесть последовательных этапов — от упаковки сообщества до постоянного потока клиентов."
        />

        <div className="relative mt-14">
          <div className="absolute top-8 left-0 right-0 hidden lg:block h-px bg-gradient-to-r from-transparent via-primary-500/40 to-transparent"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {processSteps.map((step, index) => (
              <Reveal key={step.step} delay={index * 80} className="h-full">
                <div className={`relative h-full p-6 rounded-lg border transition-colors ${
                  index === processSteps.length - 1
                    ? 'bg-primary-500/10 border-primary-400/50'
                    : 'bg-background-100/70 border-background-200/70 hover:border-primary-400/60'
                }`}>
                  <span className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border border-primary-500/40 font-heading font-extrabold text-xl text-primary-300">
                    {step.step}
                  </span>
                  <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{step.title}</h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}